export default "__VITE_ASSET__D52WUuP4__"